import { render, staticRenderFns } from "./longmendiao.vue?vue&type=template&id=dcc116be&scoped=true"
var script = {}
import style0 from "./longmendiao.vue?vue&type=style&index=0&id=dcc116be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcc116be",
  null
  
)

export default component.exports